import axios from "axios";
import { configureAxiosInstance, getNormalizedApiBaseUrl } from "./backendApi";

export const axiosIns = axios.create({
  baseURL: getNormalizedApiBaseUrl(),
});

configureAxiosInstance(axiosIns, { mode: "response" });
